import { render, staticRenderFns } from "./InventoryCardComponent.vue?vue&type=template&id=3da0c49a&scoped=true"
import script from "./InventoryCardComponent.js?vue&type=script&lang=js&external"
export * from "./InventoryCardComponent.js?vue&type=script&lang=js&external"
import style0 from "./InventoryCardComponent.vue?vue&type=style&index=0&id=3da0c49a&prod&lang=scss&scoped=true"
import style1 from "./InventoryCardComponent.vue?vue&type=style&index=1&id=3da0c49a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da0c49a",
  null
  
)

export default component.exports